import { useOutletContext } from 'react-router-dom'
import { SaldoHoras } from 'service/api'

export function useImplantacaoOutletContext() {
    return useOutletContext<{
        data?: SaldoHoras[]
        competencia: string
    }>()
}
